/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationreasoninappropriate2Inputs */

const en_moderationreasoninappropriate2 = /** @type {(inputs: Moderationreasoninappropriate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inappropriate content`)
};

const de_moderationreasoninappropriate2 = /** @type {(inputs: Moderationreasoninappropriate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unangemessener Inhalt`)
};

/**
* | output |
* | --- |
* | "Inappropriate content" |
*
* @param {Moderationreasoninappropriate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationreasoninappropriate2 = /** @type {((inputs?: Moderationreasoninappropriate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationreasoninappropriate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationreasoninappropriate2(inputs)
	return de_moderationreasoninappropriate2(inputs)
});
export { moderationreasoninappropriate2 as "moderationReasonInappropriate" }